import { createFileRoute } from '@tanstack/react-router';
import { AdminPickupCostPalletPage } from '@/features/admin/admin-pickup-cost-pallet-page';

export const Route = createFileRoute('/admin/pickup-cost-pallet/')({
  component: AdminPickupCostPalletRoute,
});

function AdminPickupCostPalletRoute() {
  return <AdminPickupCostPalletPage />;
}
